import React from 'react'
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import BidHistoryFilter from 'components/bid_history/bidHistoryFilter';
import BidHistoryTableBodyRow from 'components/bid_history/bidHistoryTableBodyRow';
import BidHistoryTableHeader from 'components/bid_history/bidHistoryTableHeader';
import SearchFilterModal from 'components/marketplace/searchFilterModal';
import { PulseLoader } from 'react-spinners';

class BidHistory extends React.Component {
  constructor(props) {
    super(props);
    let params = qs.parse(location.search.slice(1))

    this.state = {
      showModal: false,
      bidHistory: {},
      filterOptions: {},
      selectedMakes: params.by_make || [],
      selectedModels: params.by_model || [],
      selectedStatus: params.by_status || [],
      selectedGroups: params.by_group || [],
      sortDirection: params.by_order ? params.by_order.direction || 'desc' : 'desc',
      sortOption: params.by_order ? params.by_order.column || 'end_time' : 'end_time',
      loadingVehicles: true,
    }

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchBidHistory = this.fetchBidHistory.bind(this);
    this.handleSortDirection = this.handleSortDirection.bind(this);
    this.handleSortOption = this.handleSortOption.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  componentWillMount() {
    const { } = this.state
    this.fetchBidHistory();
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  handleCheckbox(event) {
    const target = event.target;
    const option = target.value;
    const value = target.checked;
    const name = target.name;
    let selectedOption = this.state[option];

    if (value) {
      selectedOption.push(name)
    } else {
      selectedOption = selectedOption.filter(option => option !== name)
    }

    this.setState({
      bidHistory: {},
      loadingVehicles: true,
      [option]: selectedOption
    }, this.fetchBidHistory.bind(this))
  }

  handleSortDirection(event) {
    const direction = event.target.value
    this.setState({ sortDirection: direction }, this.fetchBidHistory.bind(this))
  }

  handleSortOption(event) {
    const option = event.target.value
    this.setState({ sortOption: option }, this.fetchBidHistory.bind(this))
  }

  fetchBidHistory() {
    const { selectedMakes, selectedModels, selectedStatus, selectedGroups, sortDirection, sortOption } = this.state
    let params = {
      by_make: selectedMakes,
      by_model: selectedModels,
      by_status: selectedStatus,
      by_group: selectedGroups,
      by_order: {
        column: sortOption,
        direction: sortDirection,
      },
    }
    let pageUrl = '?' + qs.stringify(params, { arrayFormat: 'brackets' })
    window.history.pushState('', '', pageUrl);

    axios({
      method:'get',
      url:'/bid_history.json',
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
      responseType:'json'
    })
    .then((response) => {
      let options = [[],[],[],[]]
      response.data.filter_options_for_histories.map((history) => {
        options[0].push(history.make_name)
        options[1].push(history.model_name)
        options[2].push(history.state)
        options[3].push(history.product_type)
      })
      this.setState({ 
        bidHistory: response.data,
        filterOptions: options
      })
      return null;
    }).catch((error) => {
      console.log(error)
    });
  }

  render() {
    const { bidHistory } = this.state;
    let renderBidHistory = null

    if (bidHistory.histories) {
      renderBidHistory = bidHistory.histories.map((history) => {
        return <BidHistoryTableBodyRow key={history.id} history={history} />
      })
    }

    return (
      <section>
        <div className="filter-section visible-xs visible-sm text-center btn btn-white" onClick={this.openModal}>
          <span>Filter</span>
        </div>
        <SearchFilterModal showModal={this.state.showModal} closeModal={this.closeModal}>
          <BidHistoryFilter
            filterOptions={this.state.filterOptions}
            selectedMakes={this.state.selectedMakes}
            selectedModels={this.state.selectedModels}
            selectedStatus={this.state.selectedStatus}
            selectedGroups={this.state.selectedGroups}
            handleCheckbox={this.handleCheckbox}/>
        </SearchFilterModal>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 visible-md visible-lg">
              <div className="float-box">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="text-content">
                      <BidHistoryFilter 
                        filterOptions={this.state.filterOptions}
                        selectedMakes={this.state.selectedMakes}
                        selectedModels={this.state.selectedModels}
                        selectedStatus={this.state.selectedStatus}
                        selectedGroups={this.state.selectedGroups}
                        handleCheckbox={this.handleCheckbox}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <BidHistoryTableHeader
                sortOption={this.state.sortOption}
                sortDirection={this.state.sortDirection}
                handleSort={this.handleSortOption}
                handleSortDirection={this.handleSortDirection}
              />
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th></th>
                    <th>Vehicle</th>
                    <th>Status</th>
                    <th>Time of bid (AEST)</th>
                    <th>Bid Price</th>
                    <th>Start Time (AEST)</th>
                    <th>End Time (AEST)</th>
                    <th></th>
                  </tr>
                </thead>
                {renderBidHistory}
              </table>
            </div>
          </div>
        </div>
      </section>
    )
  }
};

export default BidHistory;
